import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ModificationBuildingUsagesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.MODIFICATION_BUILDING_USAGES>();

    const value = values.modificationBuildingUsages.value;
    const selection = Object.keys(value)
        .filter((key) => value[key as keyof typeof value])
        .sort()
        .join("#");

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Gebäudenutzung
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues((values) => {
                                values.modificationBuildingUsages.value = {
                                    business: v.indexOf("business") >= 0,
                                    household: v.indexOf("household") >= 0,
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            value="household"
                            control={<Radio />}
                            label="Haushalt"
                            text="Wohnhaus mit einer oder mehreren Wohneinheit/en"
                            error={values.modificationBuildingUsages.error != null}
                        />
                        <FormControlLabel
                            value="business"
                            control={<Radio />}
                            label="Gewerbe"
                            text="Gewerbe, Landwirtschaft, öffentliche Einrichtungen, Ampelanlagen, Garagen, Werbeflächen, Telekommunikation oder Wasserversorgung etc."
                            error={values.modificationBuildingUsages.error != null}
                        />
                        <FormControlLabel
                            value="business#household"
                            control={<Radio />}
                            label="Haushalt und Gewerbe"
                            text="Gewerbe mit Wohneinheiten"
                            error={values.modificationBuildingUsages.error != null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
